"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.composeComponents = void 0;
const react_1 = require("react");
const fp_1 = require("lodash/fp");
const composeComponents = (components) => {
    if ((0, fp_1.isEmpty)(components)) {
        return null;
    }
    const [nextComponentDef, ...remaining] = components;
    const [Component, props] = (0, fp_1.castArray)(nextComponentDef);
    return (0, react_1.createElement)(Component, props || null, (0, exports.composeComponents)(remaining) || props?.children);
};
exports.composeComponents = composeComponents;
exports.default = (components, root) => ((props) => (0, exports.composeComponents)([
    ...(0, fp_1.isArray)(components)
        ? components
        : components(props),
    [root, props],
]));
